// The facility select auto-fills form fields from the chosen facility record via formToFacilityFieldMap. When a
// tenant has a configured default genentech-copay facility NPI (fe.defaultFacilityNpis), selecting a facility must
// NOT overwrite that default, so the npi mapping is removed. The form JSON declares the mapping unconditionally
// (tenants without a default still auto-fill NPI on selection); this strips it only when a default exists. Returns
// a NEW form JSON — the imported module-level JSON is never mutated.
export const withoutFacilityNpiAutofill = (formJson) => ({
  ...formJson,
  formSections: formJson.formSections.map((section) =>
    section.sectionName !== "facility"
      ? section
      : {
          ...section,
          rows: section.rows.map((row) => ({
            ...row,
            fields: row.fields.map((field) =>
              field.type !== "facility"
                ? field
                : {
                    ...field,
                    dedicatedFieldProps: {
                      ...field.dedicatedFieldProps,
                      formToFacilityFieldMap: (field.dedicatedFieldProps?.formToFacilityFieldMap || []).filter(
                        ([, providerKey]) => providerKey !== "npi"
                      )
                    }
                  }
            )
          }))
        }
  )
});

// Chooses the form JSON for the current tenant: the NPI-stripped variant when a default facility NPI is
// configured, otherwise the base JSON unchanged (same reference, so a caller's useMemo stays stable).
export const resolveGenentechCopayFormJson = (formJson, defaultFacilityNpi) =>
  defaultFacilityNpi ? withoutFacilityNpiAutofill(formJson) : formJson;
